import React from "react";
import {WebGLRenderer} from "three";
import {ShadowTheme} from "../lib/clients/shadow/interfaces";
import {getShadowTheme} from "../lib/theme/getShadowTheme";
import Themes from "../lib/theme/Themes";

interface ThemeContextType {
    shadowTheme: ShadowTheme
    themes: ShadowTheme[]
    setTheme: (theme: ShadowTheme) => void
    setThemes: (theme: ShadowTheme[]) => void // Replace 'any' with actual type expected for theme parameter if known.
}

export const ThemeContext = React.createContext<ThemeContextType>({
    shadowTheme: getShadowTheme(Themes.SOMNIWORKS_THEME),
    setTheme(theme: ShadowTheme): void {
    },
    themes: [],
    setThemes(themes: ShadowTheme[]): void {
    }
});

interface ThemeManagerContextType {
    paletteVisible: boolean;
    setPaletteVisible: (visible: boolean) => void;
    cloudVisible: boolean;
    setCloudVisible: (visible: boolean) => void;
}

interface AppManagerContextType {
    managerEnabled: boolean
    toggleAppManager: () => void
    renderers: WebGLRenderer[],
    setRenderers: (renderers: WebGLRenderer []) => void
}

export const ThemeManagerContext = React.createContext<ThemeManagerContextType>({
    cloudVisible: false,
    paletteVisible: false,
    setCloudVisible(visible: boolean): void {
    },
    setPaletteVisible(visible: boolean): void {
    }
});

export const AppManagerContext = React.createContext<AppManagerContextType>(
        {
            managerEnabled: false,
            toggleAppManager: () => {
            },
            renderers: [],
            setRenderers: (renderers: WebGLRenderer []) => {
            }
        }
);
